import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'

const SelectLanguage = props => {
  return (
    <div className="languages">
      <ul>
        {props.langs.map(
          lang =>
            lang.langKey == 'en' ? (
              <li
                key={lang.langKey}
                className={lang.selected ? 'current-lang' : null}
              >
                <Link to={lang.link} key={lang.langKey}>
                  English
                </Link>
              </li>
            ) : (
             ""
            )
        )}
      </ul>
    </div>
  )
}

SelectLanguage.propTypes = {
  langs: PropTypes.array,
}

export default SelectLanguage



// WEBPACK FOOTER //
// ./src/components/SelectLanguageEnHeader.js